import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Filter } from 'lucide-react';
const stats = [{
  icon: Filter,
  value: '95%',
  label: 'Reduction in Manual Screening Time'
}, {
  icon: Clock,
  value: '16 Days',
  label: 'Faster Time to Fill'
}];
export function Stats() {
  return <section className="py-20 bg-slate-900 border-y border-slate-800" data-id="element-127">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-128">
        <div className="grid md:grid-cols-2 gap-12" data-id="element-129">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="text-center" data-id="element-130">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-blue-500/10 mb-5" data-id="element-131">
                <stat.icon className="w-6 h-6 text-blue-500" data-id="element-132" />
              </div>
              <div className="text-5xl md:text-6xl font-display font-bold text-white mb-3" data-id="element-133">
                {stat.value}
              </div>
              <div className="text-base font-medium text-slate-400" data-id="element-134">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}